import { API } from '../../apis/limeAuthUtils/apiWrapper';

/**
 * Function to get the things by thing type
 * @param thingType Type of thing
 * @param region Region selected by user
 * @returns {Promise<any>}
 */
export async function getThingsByThingType(thingType, region) {
    const apiName = `${region}/v1/device-registry`;
    const myInit = {
        queryStringParameters: { thingType },
    };
    return API.get(apiName, '', myInit);
}
